export default __webpack_public_path__ + "a5bb110970e9ade839fadef7dd25dde2.png";